<template>

  <div>
    <div>
      <select
        v-if="chartTypes"
        v-model="selectedChart"
        :disabled="!chartTypes"
        @change="chartChanged"
      >
        <option disabled selected hidden :value="null">Choose chart</option>
        <option
          v-for="type in chartTypes"
          :key="type.id"
          :value="type.id"
        >{{ type.translated }}
        </option>
      </select>
      <div v-if="selectedChart && (showRounds || showSubtypes || showTeams)" class="selectSection"
           style="box-shadow: 0 0 10px 0 rgb(0 0 0 / 50%)">
        <div class="selectSection__right">
          <div v-if="showRounds" class="selectSection__left__rounds">
            Rounds:
            <button :class="(selectedRound || turn) === round ? 'button active' : 'button'"
                    v-for="round in this.generateAllNumbers" :key="round" @click="(selectedRound=round)">
              <strong>{{ round }}</strong></button>
          </div>
          <div v-if="showTeams" class="selectSection__left__selectBox">
            Teams:
            <select class="subSelect" v-model='selectedTeam'
            >
              <option selected :value="null">----------- All teams -----------</option>
              <option
                v-for="team in allTeams"
                :key="team.id"
                :value="team.id"
              >{{ team.name }}
              </option>

            </select>
          </div>
          <div v-if="showSubtypes" class="selectSection__left__selectBox">
            Subtypes:
            <select class="subSelect" v-model='selectedSubtype'
            >
              <option selected hidden disabled :value="null">Choose subtype</option>
              <option
                v-for="subtype in allSubtypes"
                :key="subtype.id"
                :value="subtype.id"
              >
                {{ subtype.translated }}
              </option>

            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="chartSection" id="chartSection">
      <ChartSection :turn="turn"
                    :selectedChart="selectedChart"
                    :selectedRound="selectedRoundLocal"
                    :selectedTeam="selectedTeam"
                    :selectedSubtype="selectedSubtype"
      />
    </div>
  </div>
</template>

<script>

import ChartSection from "@/components/gameManager/charts/ChartSection";
import {mapGetters} from "vuex";

export default {
  name: 'SelectConfiguration',
  components: {
    ChartSection
  },
  data() {
    return {
      chartTypes: [
        {
          id: "teamRanking",
          translated: "Team ranking",
          rounds: false,
          teams: false,
          subtypes: [
            {
              id: "teamRankingByBudget",
              translated: "Budget"
            },
            {
              id: "teamRankingByCosts",
              translated: "Costs"
            },
            {
              id: "teamRankingByEarnings",
              translated: "Earnings"
            },
            {
              id: "earningsVsCosts",
              translated: "Earnings / costs",
            },
            {
              id: "teamRankingByAverageCampaignCosts",
              translated: "Average campaign costs",
            },
          ]
        },
        {
          id: "cuisineByRounds",
          translated: "Cuisines",
          rounds: false,
          teams: true,
          subtypes: []
        },
        {
          id: "productsSoldByTeams",
          translated: "Products",
          rounds: false,
          teams: true,
          subtypes: []
        },
        {
          id: "dataBoughtByTeams",
          translated: "Data quantity",
          rounds: true,
          teams: false,
          subtypes: []
        },
        {
          id: "campaignsVsData",
          translated: "Campaigns Vs Data",
          rounds: true,
          teams: false,
          subtypes: []
        }
      ],
      selectedChart: null,
      selectedTeam: null,
      selectedSubtype: null,
      selectedRound: this.turn
    };
  },
  computed: {
    ...mapGetters(['activeGame', 'ownerCurrentGame', 'gameAllTeams']),
    allTeams() {
      return this.gameAllTeams;
    },
    selectedRoundLocal() {
      return this.selectedRound;
    },
    turn() {
      return this.activeGame?.turn;
    },
    generateAllNumbers() {
      let arr = [];
      for (let i = 1; i <= this.turn; i++) {
        arr.push(i);
      }
      return arr;
    },
    showRounds() {
      return this.chartTypes.find(chart => chart.id === this.selectedChart).rounds
    },
    showTeams() {
      return this.chartTypes.find(chart => chart.id === this.selectedChart).teams;
    },
    showSubtypes() {
      return this.chartTypes.find(chart => chart.id === this.selectedChart).subtypes.length > 0;
    },
    allSubtypes() {
      return this.chartTypes.find(chart => chart.id === this.selectedChart).subtypes;
    }
  },
  methods: {
    chartChanged() {
      this.selectedTeam = null;
      this.selectedRound = this.turn;
      this.selectedSubtype = null;
    }
  }
}
</script>

<style>
</style>
